<div class="section-container row" [formGroup]="supportingDocumentForm">
    <div class="delete-icon-mobile delete-icon" (click)="onDeleteClick()">
        <mat-icon>delete</mat-icon>
    </div>
    <div class="delete-icon delete-icon-desktop" (click)="onDeleteClick()">
        <mat-icon>delete</mat-icon>
    </div>
    <div class="documents-container">
        <div *ngIf="supportingDocumentSection.documents.length === 0; then attachFiles else documents"></div>
        <ng-template #attachFiles>
            <button class="add-attachment-link add-documents-link" (click)="documentInput.click()">
                <mat-icon>attach_file</mat-icon> Upload Documents
                <input #documentInput type="file" multiple="multiple" (change)="onSelectDocument($event)" hidden>
            </button>
        </ng-template>
        <ng-template #documents>
            <app-supporting-document *ngFor="let document of supportingDocumentSection.documents" [document]="document"></app-supporting-document>
        </ng-template>
    </div>
    <div class="description">
        <mat-label>Description <span class="required-input">*</span></mat-label>
        <mat-form-field class="w-100 description-container" appearance="outline">
            <textarea formControlName="description" matInput placeholder="Enter description here..." class="description-input"></textarea>
        </mat-form-field>
    </div>
</div>